module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "my-3 d-flex col-12 p-0"
  }, [_c('div', {
    staticClass: "d-flex flex-grow-1",
    class: {
      'ml-3': !_vm.isInvoicing
    }
  }, [(_vm.isIntegrated) ? _c('button', {
    staticClass: "btn action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.disableIntegration()
      }
    }
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'Delete',
        boundariesElement: 'window'
      }),
      expression: "{content:'Delete', boundariesElement:'window'}"
    }],
    staticClass: "far fa-trash-alt fs-small mr-1"
  }), _vm._v(" Disable integration")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end",
    class: {
      'mr-3': !_vm.isInvoicing
    }
  }, [(_vm.showConnectionBtn) ? _c('button', {
    staticClass: "btn test-connection-min-width mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.getIsTestingPrimaveraConnectionLoading || _vm.disableConnectionBtn
    },
    on: {
      "click": function($event) {
        return _vm.testConnection()
      }
    }
  }, [(!_vm.getIsTestingPrimaveraConnectionLoading) ? _c('div', {
    staticClass: "ml-2"
  }, [_vm._v("\n                    Test Connection "), _c('i', {
    staticClass: "fa fa-plug fs-normal ml-2"
  })]) : _c('div', [_vm._v("\n                    Testing "), _c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showPrevBtn) ? _c('button', {
    staticClass: "btn blue mr-2 pr-4",
    attrs: {
      "type": "button",
      "disabled": false
    },
    on: {
      "click": function($event) {
        return _vm.prevStep()
      }
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-1"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mr-2"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showSaveBtn) ? _c('button', {
    staticClass: "btn mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.disableSaveBtn || _vm.loadingSaveBtn
    },
    on: {
      "click": function($event) {
        return _vm.saveIntegration()
      }
    }
  }, [(!_vm.loadingSaveBtn) ? _c('div', {
    staticClass: "ml-2"
  }, [_vm._v("\n                    Save "), _c('i', {
    staticClass: "fs-normal ml-2"
  })]) : _c('div', [_vm._v("\n                    Saving "), _c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showNextBtn) ? _c('button', {
    staticClass: "btn blue mr-2 pl-4",
    attrs: {
      "type": "button",
      "disabled": _vm.disableNextBtn
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2 mr-1"
  })]) : _vm._e(), _vm._v(" "), (_vm.showConnectBtn) ? _c('button', {
    staticClass: "btn mx-2",
    attrs: {
      "type": "button",
      "disabled": _vm.disableConnectBtn || _vm.loadingConnectBtn
    },
    on: {
      "click": function($event) {
        return _vm.connectIntegration()
      }
    }
  }, [(!_vm.loadingConnectBtn) ? _c('div', {
    staticClass: "ml-2"
  }, [_vm._v("\n                    Connect "), _c('i', {
    staticClass: "fs-normal ml-2"
  })]) : _c('div', [_vm._v("\n                    Connecting "), _c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn tertiary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af10ae2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/popupParts/bottomArea.vue
// module id = 1981
// module chunks = 0